import { render, staticRenderFns } from "./ticket-comments.vue?vue&type=template&id=98f24bb4&scoped=true&"
import script from "./ticket-comments.vue?vue&type=script&lang=js&"
export * from "./ticket-comments.vue?vue&type=script&lang=js&"
import style0 from "./ticket-comments.vue?vue&type=style&index=0&id=98f24bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f24bb4",
  null
  
)

export default component.exports